import { ComponentPropsWithRef, ReactNode } from "react";
import styles from "./Badge.module.css";
import { clsx } from "clsx";

export type BadgeProps = {
  children: ReactNode;
  color?: "yellow" | "red" | "green" | "blue" | "earthworm" | "oasis";
} & ComponentPropsWithRef<"span">;

export function Badge({ children, color, className, ...props }: BadgeProps) {
  return (
    <span className={clsx(styles.badgeRoot, className)} data-color={color} {...props}>
      {children}
    </span>
  );
}
